import React, { Fragment } from "react";
import {
  Combobox,
  Dialog,
  Menu,
  Transition,
  Disclosure,
} from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  ArchiveIcon,
  BellIcon,
  MenuAlt2Icon,
  PlusIcon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  HomeIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  DocumentIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  CheckIcon,
  SearchIcon,
  SelectorIcon,
  DotsVerticalIcon,
  ArrowSmDownIcon,
  ArrowSmUpIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";
import { Line } from "react-chartjs-2";


const labels = ["January", "February", "March", "April", "May", "June"];
const data = {
  datasets: [
    {
      label: "My First dataset",
      backgroundColor: "rgb(255, 99, 132)",
      borderColor: "rgb(255, 99, 132)",
      data: [0, 10, 5, 2, 20, 30, 45],
    },
  ],
};
const userNavigation = [{ name: 'Organization Profile', href: 'profile' },{ name: "Logout", href: "logout" }];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      firstList: [],
      secondList: [],
      thirdList: [],
      forthList: [],
    };
  }

  componentDidMount() {
    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/dashboard", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ firstList: res.data.main_dashboard_one });
        this.setState({ secondList: res.data.invoice });
        this.setState({ thirdList: res.data.purchase_order });
        this.setState({ forthList: res.data.total_receivable });
      });

    setTimeout(
      function () {
        //Start the timer
        this.setState({ loader: "" }); //After 1 second, set render to true
      }.bind(this),
      500
    );
  }

  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
        <div>
          

          {/* Static sidebar for desktop */}
          
          <div className="flex flex-col flex-1">
           

            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-gray-900">
                    Dashboard
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  {/* first*/}
                  <div>
                    <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide"></h2>
                    <ul
                      role="list"
                      className="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4"
                    >
                      {this.state.firstList.map((project) => (
                        <li
                          key={project.name}
                          className="col-span-1 flex shadow-sm rounded-md"
                        >
                          <div
                            className={classNames(
                              project.bgColor,
                              " flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md"
                            )}
                          >
                            {project.initials}
                          </div>
                          <div className="flex-1 flex text-center items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                            <div className="flex-1 px-4 py-2 text-sm truncate">
                              <a
                                href={project.href}
                                className="text-gray-900 font-medium hover:text-gray-600"
                              >
                                {project.name}
                              </a>
                              <p className="text-gray-500 text-center">
                                {project.members}{" "}
                              </p>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {/* first*/}
                  {/**Second */}
                  <div className="mt-7">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Invoice
                    </h3>
                    <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                      {this.state.secondList.map((item) => (
                        <div key={item.name} className="px-4 py-5 sm:p-6">
                          <dt className="text-base  font-normal text-gray-900">
                            {item.name}
                          </dt>
                          <dd className="mt-1 flex text-center justify-between items-baseline md:block lg:flex">
                            <div className="flex text-center items-baseline text-1xl font-semibold text-indigo-600">
                              RS: {item.stat}
                              <span className="ml-2 text-sm font-medium text-gray-500">
                                {" "}
                                {item.previousStat}
                              </span>
                            </div>
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                  {/**Second */}
                  {/**third */}
                  <div className="mt-8">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Purchase Order
                    </h3>
                    <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                      {this.state.thirdList.map((item) => (
                        <div
                          key={item.name}
                          className="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6"
                        >
                          <dt className="text-sm font-medium text-gray-500 truncate">
                            {item.name}
                          </dt>
                          <dd className="mt-1 text-3xl font-semibold text-gray-900">
                            {item.stat}
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                  {/**third */}
                  {/**Forth */}
                  <div className=" mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
                    {this.state.forthList.map((person) => (
                      <div
                        key={person.email}
                        className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                      >
                        <div className="flex-1 min-w-0">
                          <a href="#" className="focus:outline-none">
                            <span
                              className="absolute inset-0"
                              aria-hidden="true"
                            />
                            <p className="text-sm font-medium text-gray-900">
                              {person.name}
                            </p>
                            <p className="text-sm text-gray-500 truncate">
                              RS: {person.stat}
                            </p>
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/**Forth */}
                  {/**Forth */}

                  {/**Forth */}
                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>
      </>
    );
  }
}

export default Dashboard;
